import {v4 as uuidv4} from 'uuid';
import {UserClass} from '@/types/userClass';

export class InitiatorClass {
  constructor(
    public id: string | null = uuidv4(),
    public title = '',
    public logo = '',
    public desc = '',
    public alias = '',
    public user: string | UserClass = ''
  ) {
  }
}
